import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ArticleViewer.css"; // Reuse SAME styling for consistency
import { apiFetch } from "../utils/apifetch";
import { useAuth } from "../App";

/* ================= HELPERS ================= */
const buildFileUrl = (path) => {
  if (!path) return null;

  try {
    const normalized = path
      .replace(/\\/g, "/")
      .replace(/^\/+/, "")
      .replace(/\/{2,}/g, "/");

    const baseUrl = import.meta.env.VITE_API_URL.replace(/\/api\/?$/, "");
    return `${baseUrl}/${normalized}`;
  } catch {
    return null;
  }
};

export default function ProfileViewer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ================= FETCH PROFILE ================= */
  useEffect(() => {
    if (!id || isNaN(Number(id))) {
      setError("Invalid profile ID");
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const res = await apiFetch(`/profile/${id}`, {}, logout, navigate);

        if (!res.ok) {
          throw new Error("Profile not found");
        }

        const data = await res.json();
        setProfile(data);
      } catch (err) {
        console.error("Profile load error:", err);
        setError("Unable to load profile");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, logout, navigate]);

  /* ================= STATES ================= */
  if (loading)
    return <div className="profile-loading">Loading profile…</div>;

  if (error)
    return <div className="profile-error">{error}</div>;

  if (!profile)
    return <div className="profile-error">No profile found</div>;

  /* ================= DATA ================= */
  const photoUrl =
    buildFileUrl(profile.PhotoPath) || "/placeholder-user.png";

  const pdfUrl = buildFileUrl(profile.WriteupPdfPath);

  const formattedDate = profile.CreatedAt
    ? new Date(profile.CreatedAt).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-";

  /* ================= UI ================= */
  return (
    <div className="article-viewer">
      {/* ===== BACK BUTTON ===== */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {/* ===== PROFILE PHOTO ===== */}
      <div style={{ marginBottom: "15px" }}>
        <img
          src={photoUrl}
          alt={profile.ProfileName || "Profile"}
          style={{
            width: "120px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
          onError={(e) => {
            e.currentTarget.src = "/placeholder-user.png";
          }}
        />
      </div>

      {/* ===== TITLE ===== */}
      <div className="subtitle-1">Title:</div>
      <div className="article-viewer-description">
        {profile.ProfileTitle || "-"}
      </div>

      {/* ===== NAME ===== */}
      <div className="subtitle-1">Name:</div>
      <h4>{profile.ProfileName || "-"}</h4>

      {/* ===== CREATED BY ===== */}
      <div className="subtitle-1">Created By:</div>
      <div className="article-viewer-description">
        {profile.CreatedByUid || "-"}
      </div>

      {/* ===== CREATED DATE ===== */}
      <div className="subtitle-1">Created on:</div>
      <div className="article-viewer-description">
        {formattedDate}
      </div>

      {/* ===== PDF (EXACT SAME STRUCTURE AS ARTICLE VIEWER) ===== */}
      <div className="article-pdf-container">
        {pdfUrl ? (
          <>
            <div className="pdf-toolbar">📄 Profile PDF</div>
            <iframe
              src={pdfUrl}
              title="Profile PDF"
              loading="lazy"
            />
          </>
        ) : (
          <div className="no-pdf">No write-up PDF uploaded</div>
        )}
      </div>
    </div>
  );
}
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import "./ProfileViewer.css";
// import { apiFetch } from "../utils/apifetch";
// import { useAuth } from "../App";

// /* ================= HELPERS ================= */
// const buildFileUrl = (path) => {
//   if (!path) return null;

//   const normalized = path
//     .replace(/\\/g, "/")
//     .replace(/^\/+/, "")
//     .replace(/\/{2,}/g, "/");

//   const baseUrl = import.meta.env.VITE_API_URL.replace(/\/api\/?$/, "");
//   return `${baseUrl}/${normalized}`;
// };

// export default function ProfileViewer() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { logout } = useAuth();

//   const [profile, setProfile] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await apiFetch(`/profile/${id}`, {}, logout, navigate);
//         const data = await res.json();
//         setProfile(data);
//       } catch {
//         setError("Unable to load profile");
//       } finally {
//         setLoading(false);
//       }
//     };

//     load();
//   }, [id, logout, navigate]);

//   if (loading) return <div className="profile-loading">Loading profile…</div>;
//   if (error) return <div className="profile-error">{error}</div>;
//   if (!profile) return null;

//   const photoUrl = buildFileUrl(profile.PhotoPath) || "/placeholder-user.png";
//   const pdfUrl = buildFileUrl(profile.WriteupPdfPath);

//   return (
//     <div className="profile-viewer">

//       {/* ===== BACK BUTTON ===== */}
//       <button className="back-btn" onClick={() => navigate(-1)}>
//         ← Back
//       </button>

//       {/* ===== PROFILE PHOTO ===== */}
//       <div className="profile-photo-view">
//         <img
//           src={photoUrl}
//           alt={profile.ProfileName || "Profile"}
//           onError={(e) => {
//             e.currentTarget.src = "/placeholder-user.png";
//           }}
//         />
//       </div>

//       {/* ===== TITLE ===== */}
//       <div className="subtitle-1">Title:</div>
//       <div className="profile-viewer-description">
//         {profile.ProfileTitle || "-"}
//       </div>

//       {/* ===== NAME ===== */}
//       <div className="subtitle-1">Name:</div>
//       <h3>{profile.ProfileName || "-"}</h3>

//       {/* ===== CREATED BY ===== */}
//       <div className="subtitle-1">Created By:</div>
//       <div className="profile-viewer-description">
//         {profile.CreatedByUid || "-"}
//       </div>

//       {/* ===== CREATED DATE ===== */}
//       <div className="subtitle-1">Created On:</div>
//       <div className="profile-viewer-description">
//         {profile.CreatedAt
//           ? new Date(profile.CreatedAt).toLocaleDateString("en-GB", {
//               day: "2-digit",
//               month: "short",
//               year: "numeric",
//             })
//           : "-"}
//       </div>

//       {/* ===== PDF ===== */}
//       <div className="profile-pdf-container">
//         {pdfUrl ? (
//           <>
//             <div className="pdf-toolbar">📄 Write-up</div>
//             <iframe
//               src={pdfUrl}
//               title="Profile Write-up"
//               loading="lazy"
//             />
//           </>
//         ) : (
//           <div className="no-pdf">No write-up PDF uploaded</div>
//         )}
//       </div>
//     </div>
//   );
// }

